import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Button, Spinner, Alert } from "react-bootstrap";
import SidebarBoarding from "../../../components/SidebarDashboard";
import CustomNavbar from "../../../components/CustomNavbar";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import multiMonthPlugin from "@fullcalendar/multimonth";
import esLocale from "@fullcalendar/core/locales/es";
import AudienceActionsModal from "../../../components/Modulo_Sanciones/AudienceActionsModal";
import ExpiredEventModal from "../../../components/Modulo_Sanciones/ExpiredEventModal";
import AudiencesEditModal from "../../../components/Modulo_Sanciones/AudiencesEditModal";
import "./Audience.css";
import toastr from "toastr";
import { getAudiences } from "../../../redux/Modulo_Sanciones/Audiences/actions";

function Audiences() {
  const [show, setShow] = useState(false);
  const [createModalVisible, setCreateModalVisible] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [expiredModalVisible, setExpiredModalVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  // Seleccion del acciones por modal
  const [selectedEventForExpiredModal, setSelectedEventForExpiredModal] = useState(null);
  const [selectedEventForEditModal, setSelectedEventForEditModal] = useState(null);

  const dispatch = useDispatch();
  const { audiencesActions, loading, audiencesActionsError } = useSelector((state) => state.audiencesActions);

  //Obtiene las audiencias
  useEffect(() => {
    dispatch(getAudiences());
  }, [dispatch]);

  const onShowSidebar = () => setShow(!show);

  //Validaciones de fecha
  
  const isDateValid = (date) => {
    const currentDate = new Date();
    const selectedDateObj = new Date(date);
    return selectedDateObj >= currentDate.setHours(0, 0, 0, 0);
  };

  const handleDateClick = (info) => {
    if (isDateValid(info.date)) {
      setSelectedDate(info.date);
      setCreateModalVisible(true);
    } else {
      toastr.info("La fecha debe ser posterior a la actual.");
    }
  };

  const isEventPast = (eventEndDate) => {
    const currentDate = new Date();
    const eventEndDateObj = new Date(eventEndDate);
    return eventEndDateObj < currentDate;
  };

  // Manejadores de eventos

  const handleEventClick = (info) => {
    const event = info.event;
    if (isEventPast(event.end)) {
      setSelectedEventForExpiredModal(event);
      setExpiredModalVisible(true);
    } else {
      setSelectedEventForEditModal(event);
      setEditModalVisible(true);
    }
  };

  const handleEventDrop = (info) => {
    const event = info.event;
    setSelectedEventForEditModal(event);
    setEditModalVisible(true);
  };

  const handleCloseCreateModal = () => {
    setCreateModalVisible(false);
    setSelectedDate(null);
  };

  const handleCloseEditModal = () => {
    setEditModalVisible(false);
    setSelectedEventForEditModal(null);
  };

  const handleCloseExpiredModal = () => {
    setExpiredModalVisible(false);
    setSelectedEventForExpiredModal(null);
  };

  return (
    <>
      <SidebarBoarding show={show} onShowSidebar={onShowSidebar} />
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">
              Planificación de Audiencias Disciplinarias
            </h6>
            <Button
              variant="light"
              size="sm"
              className="rounded-circle"
              onClick={() => setCreateModalVisible(true)}
            >
              <i className="material-icons">add</i>
            </Button>
          </div>

          {loading && (
            <div className="loading-overlay">
              <div className="loading-content">
                <Spinner animation="border" role="status" />
                <span className="ml-2">Cargando audiencias...</span>
              </div>
            </div>
          )}

          {audiencesActionsError && (
            <Alert variant="danger" className="mt-3">
              Error al cargar las audiencias: {audiencesActionsError}
            </Alert>
          )}

          <div
            className={`calendar-container mt-3 ${
              loading ? "calendar-blur" : ""
            }`}
          >
            <FullCalendar
              plugins={[
                dayGridPlugin,
                timeGridPlugin,
                interactionPlugin,
                multiMonthPlugin,
              ]}
              initialView="multiMonthYear"
              locales={[esLocale]}
              locale="es"
              headerToolbar={{
                left: "prev,next today",
                center: "title",
                right: "multiMonthYear,dayGridMonth,timeGridWeek,timeGridDay",
              }}
              views={{
                multiMonthYear: {
                  type: "multiMonth",
                  duration: { months: 12 },
                  buttonText: "Año",
                },
                dayGridMonth: {
                  buttonText: "Mes",
                },
                timeGridWeek: {
                  buttonText: "Semana",
                },
                timeGridDay: {
                  buttonText: "Día",
                },
              }}
              editable={true}
              selectable={true}
              events={audiencesActions}
              eventClick={handleEventClick}
              eventDrop={handleEventDrop}
              eventClassNames={(info) => {
                return isEventPast(info.event.end) ? "event-past" : "";
              }}
              dateClick={handleDateClick}
            />
          </div>
        </Container>

        <ExpiredEventModal
          show={expiredModalVisible}
          event={selectedEventForExpiredModal}
          handleClose={handleCloseExpiredModal}
        />
        <AudienceActionsModal
          show={createModalVisible}
          handleClose={handleCloseCreateModal}
          selectedDate={selectedDate}
        />
        <AudiencesEditModal
          show={editModalVisible}
          handleClose={handleCloseEditModal}
          selectedEvent={selectedEventForEditModal}
        />
      </div>
    </>
  );
}

export default Audiences;